import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/logo/logo-tmt.png'


const _hoisted_1 = { class: "edu-footer-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-top-area ptb-100" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 col-sm-6" }
const _hoisted_6 = { class: "single-footer-widget" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p>We are maritime training service based on Indonesia</p><ul class=\"social-links\"><li><a href=\"https://www.facebook.com/profile.php?id=61551355237245\" target=\"_blank\"><i class=\"bx bxl-facebook\"></i></a></li><li><a href=\"https://x.com/TelanusaMT\" target=\"_blank\"><i class=\"bx bxl-twitter\"></i></a></li><li><a href=\"https://www.instagram.com/telanusamaritimetraining/\" target=\"_blank\"><i class=\"bx bxl-instagram\"></i></a></li></ul>", 2)
const _hoisted_10 = { class: "col-lg-4 offset-md-4 col-md-6 col-sm-6" }
const _hoisted_11 = { class: "single-footer-widget pl-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Contact Us", -1)
const _hoisted_13 = { class: "links-list" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "pr-line" }, null, -1)
const _hoisted_15 = { class: "footer-bottom-area" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  target: "_blank"
}, "Telanusa Maritime Training", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "logo"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("+ 6281355585758")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("service@telanusamaritimetraining.com")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/services-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Jln. Bromo 4 Blok A576 RT 03 RW 01 Bintara Jaya")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, [
          _createTextVNode(" © Copyright " + _toDisplayString(_ctx.currentYear) + " | ", 1),
          _hoisted_16,
          _createTextVNode(" | All Rights Reserved ")
        ])
      ])
    ])
  ]))
}